import React from 'react';

import { useAvailableSingleCallJobs } from 'state/context/freelancer/FreelancerAvailableJobs';

import Panel from '../collapsiblePanel/Panel';

import AvailableJobFilterForm from './AvailableJobFilterForm';
import FilterHeader from './FilterHeader';

const Filters: React.FC = () => {
  const { filterEnabled, closeFilter, setCloseFilter } =
    useAvailableSingleCallJobs();
  return (
    <Panel
      closePanel={closeFilter}
      setClosePanel={setCloseFilter}
      Header={FilterHeader}
      headerClassName={filterEnabled ? 'bg-pink opacity-1' : 'bg-gray50'}
      isOpenInitially
    >
      <AvailableJobFilterForm />
    </Panel>
  );
};
export default Filters;
